module.exports = "/_next/static/images/create-citations-apa-mla-2fe7517cfbe4e40e678284cbd9959a2c.png";